import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ScaleLoader } from 'react-spinners';
import ProjectCard from '../ProjectCard/index.js';
import { Homepage, MainContainer, Box, SubBox, Dot, ProjectsContainer, Button, Title, Loader } from './style.js'
import ThemeContext from '../../context/ThemeContext.js';

const apiStatusConstants = {
    success: "SUCCESS",
    failure: "FAILURE",
    loading: "IN_PROGRESS",
    initial: "INITIAL"
}

const ProjectsPage = () => {
    const location = useLocation()
    const apiUrl = `https://portfoliobackend-l8ac.onrender.com${location.pathname}${location.search}` //add backend url at front

    const navigate = useNavigate()
    const [projects, setProjects] = useState([])
    const [apiResponse, setApiResponse] = useState({
        status: null,
        data: null,
        errorMsg: null
    })

    useEffect(() => {
        const getProjects = async () => {
            setApiResponse(prev => ({ ...prev, status: apiStatusConstants.loading }))
            const response = await fetch(apiUrl)
            const data = await response.json()
            if (response.ok) {
                setApiResponse({
                    status: apiStatusConstants.success,
                    data,
                    errorMsg: null
                })
                setProjects(data)
            } else {
                setApiResponse({
                    status: apiStatusConstants.failure,
                    data: null,
                    errorMsg: data.error_msg
                })
            }
        }
        getProjects()
    }, [apiUrl])
    const onClickBack = () => {
        navigate('/')
    }
    const renderFailureView = () => {
        return <div><h1>Failed</h1></div>
    }
    const renderLoadingView = () => {
        return <ThemeContext.Consumer>
            {value => (
                <Loader>
                    <ScaleLoader color={value.theme === 'light' ? '#5423a8' : '#FFFFFF'} width={10} height={60} speedMultiplier={2} barCount={5} />
                </Loader>
            )}
        </ThemeContext.Consumer>
    }
    const renderSuccessView = () => (<>
        <ProjectsContainer>
            {projects.map(eachProject => <ProjectCard key={eachProject.id} details={eachProject} />)}
        </ProjectsContainer>
    </>
    )
    const renderProjects = () => {
        const { status } = apiResponse
        switch (status) {
            case apiStatusConstants.success:
                return renderSuccessView()
            case apiStatusConstants.failure:
                return renderFailureView()
            case apiStatusConstants.loading:
                return renderLoadingView()
            default:
                return null
        }
    }
    return (
        <ThemeContext.Consumer>
            {value => (
                <Homepage theme={value.theme}>
                    <MainContainer>
                        <Title>Projects</Title>
                        {renderProjects()}
                        <Button onClick={onClickBack}>Back</Button>
                    </MainContainer>

                    <Box>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                        <SubBox><Dot></Dot></SubBox>
                    </Box>
                </Homepage>
            )}
        </ThemeContext.Consumer>
    )
}

export default ProjectsPage